module.exports = __webpack_public_path__ + "static/img/mapa_fra.277b1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa_fra.png
// module id = dWFh
// module chunks = 1